import { StyleSheet } from "@react-pdf/renderer";
import { Font } from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf",
      fontWeight: 300,
    },
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf",
      fontWeight: 400,
    },
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf",
      fontWeight: 500,
    },
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
      fontWeight: 600,
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    padding: "15px",
    fontFamily: "Roboto",
    fontSize: "8px",
  },
  section: {
    flexGrow: 1,
  },
  body: {
    boxSizing: "border-box",
    float: "none !important",
    padding: "15px",
  },
  logo: {
    marginBottom: "5px",
  },
  about: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  left: {
    width: "50%",
    // borderRight: "1px solid #f39200",
    borderRight: "1px solid #80caef",
  },

  right: {
    width: "50%",
    paddingLeft: "5px",
  },
  "left-logo": {
    width: "50%",
    display: "flex",
    justifyContent: "center",
    margin: "5px 0",
    alignItems: "center",
  },
  "right-logo": {
    width: "50%",
    paddingLeft: "5px",
    display: "flex",
    justifyContent: "center",
    margin: "5px 0",
    alignItems: "center",
  },
  "right-1": {
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
  },
  col: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    textAlign: "center",
  },
  "left-1": {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    justifyContent: "space-between",
  },
  "left-sm-flex": {
    display: "flex",
    justifyContent: "space-between",
    paddingRight: "5px",
    flexDirection: "row",
    marginBottom: "5px",
  },
  "md-flex": {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    marginBottom: "5px",
  },
  label: {
    width: "55%",
    fontSize: "9px",
  },
  "wide-label": {
    width: "85%",
    fontSize: "9px",
  },

  "section-wrapper": {
    border: "1px solid #80caef",
    //border: "1px solid #f39200",
    pageBreakAfter: "always",
    pageIbreakInside: "avoid",
    width: "100%",
  },
  "section-wrapper calc": {
    border: "2px solid " /*#80caef*/,
    padding: "5px",
  },
  "label calc": {
    fontSize: { xs: "12px", lg: "16px" },
  },
  "value calc": {
    fontSize: { xs: "12px", lg: "16px" },
  },
  heading: {
    backgroundColor: "black",
    //color: "#f39200",
    color: "#80caef",
    textAlign: "center",
    padding: "10px",
  },
  title: {
    fontSize: "12px",
  },
  flex: {
    display: { xs: "block", lg: "flex" },
    justifyContent: "space-between",
    padding: "5px 5px 0 5px",
    flexDirection: "row",
  },
  "flex-1": {
    display: "flex",
    padding: "10px 5px",
    gap: "30px",
    flexDirection: "row",
  },
  "img-flex": {
    paddingLeft: "15px",
    flex: 1,
    display: "flex",
  },
  "img-center": {
    display: "flex",
    justifyContent: "center",
    margin: "15px 0",
    alignItems: "center",
  },
  "heading-flex": {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  white: {
    color: "white",
  },
  "inner-flex": {
    paddingLeft: "15px",
    width: "95%",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
  },
  "inner-inner": {
    gap: "25px",
    flexDirection: "row",
  },
  "sm-pad": {
    paddingLeft: "5px",
    fontSize: "12px",
    marginTop: "10px",
  },
  extras: {
    borderTop: "1px solid #80caef",
    //borderTop: "1px solid #f39200",
    padding: "10px 5px",
    fontSize: "12px",
  },
  "extras-left": {
    borderTop: "1px solid #80caef",
    //borderTop: "1px solid #f39200",
    padding: "10px 0px",
    fontSize: "12px",
  },
  cool: {
    color: "#80caef",
  },
  heat: {
    color: "red",
  },
  "no-pad": {
    padding: "0",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    rowGap: "20px",
    padding: "30px 60px",
  },
  "grid-item": {
    justifySelf: "center",
  },
  "md-flex div:nth-child(2), sm-flex div:nth-child(2)": {
    textAlign: "right",
  },
  value: {
    fontSize: "9px",
    textAlign: "right",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 10,
    paddingTop: 10,
    paddingBottom: 10,
  },
  address: {
    fontSize: "10px",
  },
  "sm-title": {
    fontSize: "12px",
    marginBottom: "10px",
  },
  imgCent: {
    width: "50%",
    display: "flex",
    justifyContent: "center",
  },
  helper: {
    "padding-left": "5px",
    "margin-top": "10px",
    "font-size": "12px",
  },
});

export default styles;
